<script>
  import copy from "../data/doc.json";
</script>

<div>
  <h3>{copy.methodTitle}</h3>

  {#each copy.methods as { value }}
    <p>{value}</p>
  {/each}
</div>

<style>
  div {
    max-width: 40em;
    margin: 0 auto;
    padding: 1em;
    border-top: 1px solid var(--fg);
  }

  h3 {
    margin-bottom: 1em;
  }

  p {
    line-height: 1.4;
  }
</style>
